import { FileCategory } from '@/types/document.dto';

export const FILE_CATEGORY_LABELS: Record<number, string> = {
  [FileCategory.Prescription]: 'Prescription',
  [FileCategory.DischargeSummary]: 'Procedures',
  [FileCategory.LabReport]: 'Reports',
  [FileCategory.MedicalBill]: 'Bills',
  [FileCategory.InsuranceCard]: 'Insurance Card',
  [FileCategory.Identity]: 'Identity',
  [FileCategory.Other]: 'Other',
};

export function mapHealthEventsForDisplay(events: any[]): { title: string; source: string }[] {
  return (events || []).map(ev => ({
    title: ev.event,
    source:
      ev.type === 'healthMemory'
        ? 'Source: Health Memory'
        : `Source: Health profile > ${
            ev.type === 'conditions' ? 'Conditions'
            : ev.type === 'organTransplants' ? 'Organ Transplants'
            : ev.type === 'deviceImplants' ? 'Implanted Devices'
            : ev.type === 'hospitalizations' ? 'Hospitalizations'
            : ev.type === 'surgeries' ? 'Surgeries'
            : ev.type
          }`,
  }));
}
